"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Root = exports.RightSide = exports.LeftSide = void 0;
var _mui = require("@ori-ui/mui");
var _constants = require("./constants");
const Root = exports.Root = (0, _mui.styled)('div')((param)=>{
    let { theme } = param;
    return {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        justifyItems: 'center',
        gap: theme.spacing(6),
        padding: 0,
        width: '100%',
        overflow: 'hidden',
        [theme.breakpoints.up('sm')]: {
            flexDirection: 'row'
        },
        [theme.breakpoints.up('md')]: {
            gap: theme.spacing(8)
        }
    };
});
const LeftSide = exports.LeftSide = (0, _mui.styled)('div')((param)=>{
    let { theme } = param;
    return {
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: theme.spacing(3),
        [theme.breakpoints.up('md')]: {
            width: _constants.LEFT_IMAGE_DESKTOP_WIDTH
        }
    };
});
const RightSide = exports.RightSide = (0, _mui.styled)('div')((param)=>{
    let { theme } = param;
    return {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        width: '100%',
        gap: theme.spacing(6),
        [theme.breakpoints.up('md')]: {
            width: _constants.RIGHT_IMAGE_DESKTOP_WIDTH,
            gap: theme.spacing(4)
        },
        /** Last element on mobile have to have only 3 gap */ [theme.breakpoints.down('md')]: {
            '& > *:last-child': {
                marginTop: theme.spacing(-3)
            }
        }
    };
});
